#complianceOverviewContainer {
  padding-top: var(--spacer);
  padding-bottom: var(--spacer);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
  cursor: default;
  position: relative;

  border: 1px solid var(--chart-101-pressed-dividers);

  .overview-section {
    display: flex;
    flex: 1;
    flex-flow: column;
    align-items: center;
    gap: var(--spacer);

    .section-title {
      display: flex;
      align-items: center;
      text-align: center;
      gap: var(--spacer);
      margin-left: var(--spacer);
      margin-right: var(--spacer);
    }

    span {
      color: var(--main-titles-inputs-600);
    }

    .section-title.compliantCount {
      color: var(--green-layout-100-primary-green);
    }

    .section-title.nonCompliantCount {
      color: var(--red-layout-300-primary);
    }

    .section-title.ignoredCount {
      color: var(--chart-300-icon-buttons);
    }
  }

  .info-section {
    display: flex;
    flex: 1;
    flex-flow: wrap;
    align-items: center;
    gap: var(--spacer);
    padding-left: var(--spacer);

    .section-title {
      display: flex;
      align-items: center;
      gap: var(--spacer);
    }

    .section-value {
      display: flex;
      align-items: center;
      gap: var(--spacer);
      padding-left: calc(var(--spacer) * 2);
      padding-right: var(--spacer);
    }

    span {
      color: var(--main-titles-inputs-600);
    }
  }

  .loader-item {
    display: flex;
    flex: 1;
    flex-flow: column;
    align-items: center;
    gap: calc(var(--spacer) * 3);
    cursor: default;
    width: 75%;
  }

  gz-loader {
    height: fit-content;
    width: 75%;
  }
}

.separator {
  background-color: var(--chart-101-pressed-dividers);
  width: 1px;
  height: calc(var(--spacer) * 10);
  margin: auto;
}
